var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.8768 32.509H21.4463V32.5928H23.8768V32.509Z",
    fill: "#76BC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.1165 22.2709H16.686V22.3547H19.1165V22.2709Z",
    fill: "#76BC21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2491 11.2224H20.7757M10.2491 16.1001H20.7757M36.75 18.9999V35.5776L34.4201 34.3037L31.3023 32.6107H17.8424C15.7471 32.6107 14.0541 30.9178 14.0541 28.8225V22.3691H22.9716C23.927 22.3691 24.7819 21.9836 25.4188 21.3634C26.0893 20.7264 26.4916 19.838 26.4916 18.8491V15.2285H32.9618C35.057 15.2285 36.75 16.9214 36.75 18.9999ZM26.5084 6.22718V18.5641C26.5084 20.6594 24.8154 22.3524 22.7201 22.3524H9.26018L3.8125 25.3192V8.75826C3.8125 6.663 5.50547 4.97003 7.60073 4.97003H25.2512C25.9552 4.97003 26.5084 5.53994 26.5084 6.22718Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.732939339fac11053a2411f49dda5af5.svg";
export { ForwardRef as ReactComponent };